import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <div id="footer">
          <div className="inner">
            <div className="footer-menu">
              <div className="info-menu">
                <Link title="이용약관" to="/terms">
                  이용약관
                </Link>
                <Link title="개인정보처리방침" to="/privacy">
                  <strong style={{fontWeight: "bolder", color: "cornflowerblue"}}>개인정보처리방침</strong>
                </Link>
                <Link title="고객센터" to="/notice">
                  고객센터
                </Link>
              </div>
              <a title="전화연결" href="tel:1566-2119" className="tel">
                대표전화 1566-2119
              </a>
            </div>
            <div className="footer-contact">
              <div className="footer-logo">산업통상자원부</div>
              <address>
                [산업통상자원부] 30118 세종특별자치시 한누리대로 402 12동, 13동
                <br /> [한국무역정보통신] 13493 경기도 분당구 판교로 338(판교테크노밸리) 한국전자무역센터
              </address>
              <p className="copyright">Copyright © 산업통상자원부 &amp; KTNET. All Right Reserved.</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Footer
